import axios from "axios";
import Cookies from "js-cookie";

export interface UploadGuideInvoiceResult {
    id: string;
    guideId: string;
    month: number;
    year: number;
}

export interface UploadGuideInvoiceAdminInput {
    file: File;
    guideId: string;
    month: number;
    year: number;
}

const getAuthHeaders = () => {
    const accessToken = Cookies.get("accessToken");
    return {
        "Content-Type": "multipart/form-data",
        Authorization: accessToken ? `Bearer ${accessToken}` : "",
    };
};

export const uploadGuideInvoice = async (file: File): Promise<UploadGuideInvoiceResult> => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/guide-invoices/upload`,
        formData,
        { headers: getAuthHeaders() }
    );

    return response.data;
};

export const uploadGuideInvoiceAdmin = async ({
    file,
    guideId,
    month,
    year,
}: UploadGuideInvoiceAdminInput): Promise<UploadGuideInvoiceResult> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("guideId", guideId);
    formData.append("month", String(month));
    formData.append("year", String(year));

    const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/guide-invoices/admin/upload`,
        formData,
        { headers: getAuthHeaders() }
    );

    return response.data;
};
